<template>
  <modal :name="'modal-calendar'">
    <div slot="content">
      <h4 class="secondary-font h5 align-center cl-light-gray m0 letter-spacing-1 uppercase">
        {{ $t('select the rental date') }}
      </h4>
      <p class="h6 align-center cl-light-gray">
        {{ $t('Pick a delivery date 1-2 days before your event') }}
      </p>
      <datepicker-c v-if="!loading" :min-date="getFirstAvaliableDate" class="inline-block h-full" :attributes="attrs" @input="changeDateRange" v-model="date" :disabled-dates="getFullBookedDates" is-required />
      <div class="legend row">
        <div class="mt15 col-xs-6 flex middle-xs h6 cl-light-gray">
          <span class="legend-avaliable" />{{ $t('Possible to borrow') }}
        </div>
        <div class="mt15 col-xs-6 flex middle-xs h6 cl-light-gray">
          <span class="legend-unavaliable" />{{ $t('Impossible to borrow') }}
        </div>
        <div class="mt15 col-xs-6 flex middle-xs h6 cl-light-gray">
          <span class="legend-start" />{{ $t('The package will be delivered to you') }}
        </div>
        <div class="mt15 col-xs-6 flex middle-xs h6 cl-light-gray">
          <span class="legend-end" />{{ $t('You need to send the package back on this day') }}
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from 'theme/components/core/Modal.vue'

export default {
  components: {
    DatepickerC: () => import('v-calendar/lib/components/date-picker.umd'),
    Modal
  },
  watch: {
    date: {
      handler () {
        this.onDateChange()
      }
    }
  },
  data () {
    return {
      date: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      getFirstAvaliableDate: 'calendar/getFirstAvaliableDate',
      getBookedDatesFull: 'calendar/getBookedDatesFull',
      getBlockedDays: 'calendar/getBlockedDays',
      getActivePeriod: 'calendar/getActivePeriod',
      getSelectedDate: 'calendar/getSelectedDate',
      getCurrentProduct: 'product/getCurrentProduct',
      getUserBalance: 'user/getBalance'
    }),
    attrs () {
      return [
        {
          highlight: {
            start: { color: 'blue', fillMode: 'solid' },
            base: { color: 'blue', fillMode: 'light' },
            end: { color: 'blue', fillMode: 'solid' }
          },
          dates: { start: this.getFirstAvaliableDate, span: 1 }
        }
      ]
    },
    getFullBookedDates () {
      return this.getBookedDatesFull.concat(this.getBlockedDays)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loading = false
    })
  },
  methods: {
    changeDateRange () {
      this.attrs[0].dates.start = this.date
      this.attrs[0].dates.span = Number(this.getActivePeriod)
      this.$bus.$emit('modal-hide', 'modal-calendar')
      this.$store.commit('calendar/setDate', this.date)
      if (this.getCurrentProduct.subscription_points && this.getUserBalance >= 1) {
        this.getCurrentProduct.product_option.extension_attributes.subscription = true
      }
    },
    onDateChange () {
      if (!this.date) return
      this.$store.commit('calendar/setDateValidation', !!this.date)
      this.selectedDate = new Date(this.date).toLocaleDateString('pl-PL') + ' - ' + new Date(this.getEndDate()).toLocaleDateString('pl-PL')
      this.$store.commit('calendar/setSelectedDate', this.selectedDate)
      this.$bus.$emit('setCalendarDate', { start: this.date, end: this.getEndDate() })
    },
    getEndDate () {
      let p = this.getActivePeriod ? Number(this.getActivePeriod) - 1 : null
      let d = this.date ? new Date(this.date) : null
      return (typeof p === 'number' && d) ? d.setUTCDate(d.getUTCDate() + p) : null
    }
  }
}
</script>

<style lang="scss">
.vc-container {
  width: 100% !important;
  border: 0 !important;
}
.vc-title {
  font-size: 14px !important;
  font-family: 'Poppins';
  color: #383838 !important;
  font-weight: 500 !important;
}
.vc-arrow .vc-svg-icon{
  color: #555555;
}
.vc-weekday {
  color: #C2C2C2 !important;
  font-size: 12px !important;
  font-family: 'Poppins';
  font-weight: 500 !important;
}
.vc-day {
  @media (max-width: 767px) {
    min-height: 38px !important;
  }
  min-height: 58px !important;
  font-family: 'Poppins';
  font-weight: 500;
  border: 1px solid #DFDFDF;
  font-size: 12px;
  margin: 1px;
  align-items: stretch !important;
}
.vc-day-content {
  background-color: #fff;
  color: #9D9D9D !important;
  width: 100% !important;
  height: auto !important;
  border-radius: 0 !important;
}
.vc-day-content.is-disabled {
  background-color: #DFDFDF;
}
.vc-day-content:hover {
  background-color: #3E3E3E !important;
  font-weight: 500 !important;
}
.vc-day-content:focus {
  font-weight: 500 !important;
}
.vc-highlights + span {
  background-color: #3E3E3E !important;
  font-weight: 500 !important;
}
.vc-highlights {
  z-index: 0 !important;
}
.vc-day-box-right-center::before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: white;
  top: 5px;
  left: 5px;
  position: absolute;
}
.mobile-padding {
  @media (min-width: 767px) {
      padding-top: 0px;
    }
}
.vc-day-box-left-center::after {
  content: '';
  width: 12px;
  height: 12px;
  background-color: white;
  bottom: 5px;
  right: 5px;
  position: absolute;
}
/* .vc-highlights {
  z-index: inherit !important;
} */
.vc-highlight {
  background-color: initial !important;
}
.vc-weeks {
  padding: 0 !important;
}
.vc-popover-content.direction-bottom {
  background-color: #3E3E3E !important;
}
.vc-nav-item.is-active {
  background-color: #fff !important;
  color: #3E3E3E !important;
}
</style>

<style lang="scss" scoped>

</style>
